module.exports = __webpack_public_path__ + "img/img-avatar07.40f7034c.jpg";